import { Application } from "pixi.js";
import {ActivityType} from "@/types/ActivityType.ts";

export default class DagobahModel {
    public assets = {};
    public className: string = "Reading Horizons";
    public configData: any;
    public curApplication: Application | undefined;
    //public exitBtn: ImageButton;
    public grade: string;
    //public leafData: any;
    public lessonId: number;
    public lessonName: string = "Discovery Park";
    public section: string;
    public showDebug: boolean;
    public showExitBtn: boolean;
    //public showExitButton: boolean;
    public stageWidth: number = 1366;
    public stageHeight: number = 768;
    public studentId: string;
    public studentName: string;
    public seenCutscenes: number[];

    private static _instance: DagobahModel = new DagobahModel();

    private _activityName: ActivityType;
    private _centerX: number = 0;
    private _centerY: number = 0;
    private _devicePixelRatio: number = window.devicePixelRatio || 1;
    private _resolution: number = 1; //window.devicePixelRatio || 1;
    private _screenHeight:number = 0;
    private _screenWidth:number = 0;

    public get activityName(): ActivityType {
        return this._activityName;
    }

    public set activityName(name: ActivityType) {
        this._activityName = name;
    }

    public get centerX(): number {
        if (this._centerX == 0) {
            this._centerX = this.stageWidth / 2;
        }
        return this._centerX;
    }

    public get centerY(): number {
        if (this._centerY == 0) {
            this._centerY = this.stageHeight / 2;
        }
        return this._centerY;
    }

    public get devicePixelRatio(): number {
        return this._devicePixelRatio;
    }

    public get resolution(): number {
        return this._resolution;
    }

    public set resolution(value: number) {
        this._resolution = value;
    }

    public get screenHeight():number
    {
        if(this._screenHeight == 0)
        {
            this._screenHeight = this.curApplication!.screen.height;
        }
        return this._screenHeight;
    }

    public get screenWidth():number
    {
        if(this._screenWidth == 0)
        {
            this._screenWidth = this.curApplication!.screen.width;
        }
        return this._screenWidth;
    }

    public static getInstance(): DagobahModel {
        return this._instance;
    }
}
